import AxiosFactory from './core/axios-factory';
import { stringify } from 'qs';
import { getToken, setToken } from '@/utils/auth';
import { handleStatus } from './handler/handle-status';
import JSONbig from 'json-bigint';

/** 是否为开发环境 */
const is_dev = process.env.NODE_ENV === 'development';
/** baseURL */
const base_url = is_dev ? process.env.VUE_APP_BASE_API : (process.env.VUE_APP_URL + process.env.VUE_APP_BASE_API);
/** 创建axios工厂类实例 */
const service = new AxiosFactory(
  {
    baseURL: base_url,
    timeout: 300 * 1000,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json', // POST默认请求规范，JSON格式
    },
    withCredentials: false, // 跨域请求时是否需要使用凭证
    paramsSerializer: (params) => {
      // 新接口对分页参数进行了调整，需使用page_size替换limit，为了避免改动公共表格组件影响旧接口，故在此做兼容处理
      if (Object.prototype.hasOwnProperty.call(params, 'limit')) {
        Object.assign(params, { page_size: params.limit });
        delete params.limit;
      }
      // 去除null和undefined
      return stringify(params, { skipNulls: true, arrayFormat: 'indices' });
    },
    transformResponse: (response) => {
      // 超出15位数的number类型参数，统一转化为string类型，避免参数因超出js number类型安全范围导致精度丢失问题
      return JSONbig({ storeAsString: true }).parse(response);
    },
  },
  {
    interceptors: {
      // 请求拦截器
      requestInterceptors: (config) => {
        const token = getToken();
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + getToken(); // 携带token，Bearer字符串为后端框架所需
        }
        return config;
      },
      // 响应拦截器
      responseInterceptors: (response) => {
        const {
          headers: { authorization } = {},
          data = {},
        } = response || {};

        if (authorization) {
          setToken(authorization);
          Object.assign(data, { token: authorization });
        }
        return response;
      },
      responseInterceptorsCatch: (error) => {
        const {
          status,
          data: { errors = '请求失败，未知错误！' } = {},
        } = error.response || {};
        // 状态码处理
        handleStatus(status, errors);
        return Promise.reject(error);
      },
    },
  }
);

export default service;
